import type { Account } from './account';
import type { AdUnit } from './adUnit';
import type { AppCategory } from './appCategory';
import type { EnrichedBlockedSeats } from './blockedSeats';
import type { Brand } from './brand';
import type { Buyer } from './buyer';
import type { CommercialAgreementApi } from './commercialAgreement';
import type { CreativeInfoApi } from './creativeInfo';
import type { DealApi } from './deal';
import type { Domain } from './domain';
import type { FeeApi } from './fee';
import type { FloorRuleApi } from './floorrule';
import type { BidderOrder } from './gqlTypes';
import type { ConstValues } from './helpers';
import type { LineItem } from './lineItem';
import type { Seat } from './seat';
import type { SiteApi } from './site';
import type { User } from './user';

export const Resource = {
  ACCOUNT: 'account',
  ADUNIT: 'adunit',
  APP_CATEGORY: 'appcategory',
  BLOCKED_SEATS: 'blockedseats',
  BRAND: 'brand',
  BRAND_FLOOR: 'floorrule',
  BUYER: 'buyer',
  COMMERCIAL_AGREEMENT: 'commercialagreement',
  CREATIVE_REVIEW: 'creativereview',
  DEAL: 'deal',
  DOMAIN: 'domain',
  FEE_CAP: 'fee',
  LINEITEM: 'lineitem',
  ORDER: 'order',
  SEAT: 'seat',
  SITE: 'site',
  USER: 'user',
} as const;
export type Resource = ConstValues<typeof Resource>;

export interface ResourcesMap {
  [Resource.ACCOUNT]: Account;
  [Resource.ADUNIT]: AdUnit;
  [Resource.APP_CATEGORY]: AppCategory;
  [Resource.BLOCKED_SEATS]: EnrichedBlockedSeats;
  [Resource.BRAND]: Brand;
  [Resource.BRAND_FLOOR]: FloorRuleApi;
  [Resource.BUYER]: Buyer;
  [Resource.COMMERCIAL_AGREEMENT]: CommercialAgreementApi;
  [Resource.CREATIVE_REVIEW]: CreativeInfoApi & { publisher_ids: string };
  [Resource.DEAL]: DealApi;
  [Resource.DOMAIN]: Domain;
  [Resource.FEE_CAP]: FeeApi;
  [Resource.LINEITEM]: LineItem;
  [Resource.ORDER]: Omit<BidderOrder, '__typename'>;
  [Resource.SEAT]: Seat;
  [Resource.SITE]: SiteApi;
  [Resource.USER]: User;
}

export const ResourceOperation = {
  CREATE: 'create',
  UPDATE: 'update',
  CLONE: 'clone',
  EXPIRE: 'expire',
} as const;

export type ResourceOperationType = ConstValues<typeof ResourceOperation>;
